import React from 'react'

export default function IcoPeople() {
    return (
        <svg
            width="14"
            height="19"
            viewBox="0 0 14 19"
            fill="none"
            className="fill-current"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M9.96898 10.7061H3.78814C1.6967 10.7061 0.00346265 12.4028 0 14.4942V18.3481H13.7606V14.4942C13.7571 12.4028 12.0604 10.7061 9.96898 10.7061Z" />
            <path d="M6.88098 9.17603C9.41488 9.17603 11.469 7.12191 11.469 4.58802C11.469 2.05412 9.41488 0 6.88098 0C4.34709 0 2.29297 2.05412 2.29297 4.58802C2.29297 7.12191 4.34709 9.17603 6.88098 9.17603Z" />
        </svg>
    )
}
